const omitBy = require('lodash/omitBy');
const isNil = require('lodash/isNil');

const getSessionHeaders = (cookies, { locale, currency, guestToken, iso: countryIso } = {}) => {
  const headers = {
    LMN_LOCALE: locale || cookies.locale,
    LMN_CURRENCY: currency || cookies.currency,
    LMN_GUEST_TOKEN: guestToken || cookies.guestToken,
    LMN_RESTRICTED_USER: cookies.userToken,
    LMN_COUNTRY_ISO: countryIso || cookies.countryIso,
  };

  return omitBy(headers, isNil);
};

const isSessionValid = (cookies) => {
  return !!cookies.guestToken;
};

module.exports = {
  getSessionHeaders,
  isSessionValid
};




// WEBPACK FOOTER //
// ./src/common/facades/eagle/helpers/session-headers.js